import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import { initSentry } from './utils/sentryConfig';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry error tracking
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Disabled StrictMode to prevent double-rendering of streaming chunks
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
